
    <mat-progress-bar mode="determinate"
                      [color]="color"
                      [value]="strength">
    </mat-progress-bar>
  